import { Logger } from 'data/common';

function debug(eventName, params) {
    Logger.debug(`MyFHE : <---------- Event Received ${eventName}`, params);
}

function bindSettingsEvents(UserInstance) {
    UserInstance.socketOn('setDeviceMode', function(args) {
        debug('setDeviceMode', args);
    });
}

export default function initBinds(UserInstance) {
    bindSettingsEvents(UserInstance);
}



// WEBPACK FOOTER //
// ./environments/myfhe/eventsSocket/User/binds.js